module.exports = __webpack_public_path__ + "static/media/landelijk.96c8ccb5.jpg";